<!-- <template>
  <div class="border rounded mt-2">
    <table class="table table-sm table-hover w-100">
      <thead>
        <tr>
          <th class="text-center" colspan="2">
            Quality status
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right w-35">
            <strong>Back order:</strong>
          </td>
          <td class="text-left w-65">
            <b-form-checkbox v-model="order.backordered" switch />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Status:</strong>
          </td>
          <td class="text-left w-65">
            <select
              name="bkStatus"
              class="form-control input-sm"
              v-model="order.status"
            >
              <option value="-1">Choose status</option>
              <option value="3">Backorder</option>
              <option value="S">Staged for Processing</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Expected date:</strong>
          </td>
          <td class="text-left w-65">
            <!-- <input
              class="form-control"
              type="date"
              name=""
              id=""
              v-model="order.backOrderDate"
            /> -->
            <a-date-picker
              style="width: 100%;"
              format="MM/DD/YYYY"
              :value="order.backOrderDate"
              @change="updateBackOrderDate"
              id="dateFrom"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Quality #:</strong>
          </td>
          <td class="text-left w-65">{{ order.qualityNum }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "QualityStatus",
  methods: {
    updateBackOrderDate(date, datestring) {
      this.order.backOrderDate = datestring;
    },
  },
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.w-35 {
  width: 35%;
}
.w-65 {
  width: 65%;
}
.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
  margin-left: -1.5em !important;
}
table {
  margin-bottom: 0px;
  border: solid grey 0.5px;
}
td {
  border: solid grey 0.5px;
}
</style> -->
